import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_text",
  "use": "dashboard_card_icon_menu_text-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_text\"><path d=\"M15.375 4v-.375h-4.75v12.75h2.042a.625.625 0 1 1 0 1.25H7.333a.625.625 0 1 1 0-1.25h2.042V3.625h-4.75V5a.625.625 0 0 1-1.25 0V3A.625.625 0 0 1 4 2.375h12a.625.625 0 0 1 .625.625v2a.625.625 0 0 1-1.067.442l-.265.265.265-.265A.625.625 0 0 1 15.375 5V4Z\" fill=\"#2D2C34\" stroke=\"#2D2C34\" stroke-width=\".75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol